import React from 'react';
import {
  Box,
  Typography,
  Avatar,
  Card,
  List,
  ListItemButton,
  Divider,
} from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { Link, useLocation } from 'react-router-dom';

export default function TopTutorsSidebar({ tutors = [], hideHeader = false }) {
  const location = useLocation();
  if (tutors.length === 0) return null;

  return (
    <Card variant="outlined" sx={{ p: 2, mt: hideHeader ? 0 : 2 }}>
      {!hideHeader && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, ml: 2 }}>
          <EmojiEventsIcon fontSize="small" color="secondary" sx={{ mr: 1 }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            Top Tutors
          </Typography>
        </Box>
      )}
      <List disablePadding>
        {tutors.map((tutor, idx) => (
          <React.Fragment key={tutor.id}>
            <ListItemButton
              component={Link}
              to={`/tutors/${tutor.id}`}
              state={{ from: location.pathname }}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                py: 1,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" sx={{ width: 16 }}>
                  #{idx + 1}
                </Typography>
                <Avatar
                  src={tutor.user?.avatar || undefined}
                  alt={tutor.full_name}
                  sx={{ width: 24, height: 24 }}
                >
                  {!tutor.user?.avatar && tutor.full_name?.[0]}
                </Avatar>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {tutor.full_name}
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {tutor.total_hours_tutored}
              </Typography>
            </ListItemButton>
            {idx !== tutors.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Card>
  );
}
